export const getGmailComposeUrl = (to, accountIndex = 0) => {
  const params = new URLSearchParams({
    view: 'cm',
    fs: '1',
    to,
    tf: '1',
  });

  return `https://mail.google.com/mail/u/${accountIndex}/?${params.toString()}`;
};